import React, { useEffect } from 'react'

/**
 * Hook to detect clicks outside an element.
 *
 * @param {*} ref
 * @param {*} handler
 */
export function useOnClickOutside(
  ref: React.RefObject<HTMLElement>,
  handler: ((event: MouseEvent | TouchEvent) => unknown) | undefined | null,
) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return
      }

      handler?.(event)
    }

    if (handler) {
      document.addEventListener('click', listener, { capture: true })
    }

    return () => {
      document.removeEventListener('click', listener, { capture: true })
    }
  }, [handler])
}
